import { FC, useCallback, useState } from 'react';
import { FiCheck, FiSquare } from 'react-icons/fi';
import Modal from 'react-modal';

import styles from './styles.module.scss';
import { validateCnpj, validateCpf } from '../../../../utils/validateCpf';
import formatCpf from '../../../../utils/formatCpf';
import { emailValidation } from '../../../../utils/EmailValidation';
import { useContactComunixFormData } from '../../../../context/ContactComunixContext';

interface indexProps {
  showContactModal: boolean;
  setShowContactModal: (value: boolean) => void;
  setShowModalConfirmedPix?: React.Dispatch<React.SetStateAction<boolean>>;
  getPix?: () => void;
}

const ModalUserContactComunix: FC<indexProps> = ({
  showContactModal,
  setShowContactModal,
  setShowModalConfirmedPix = undefined,
  getPix,
}) => {

  const [cpfCnpj, setCpfCnpj] = useState<string | null>(null);

  const {
    namePartner,
    email,
    phone,
    namePartnerStatus,
    namePartnerError,
    cpfCnpjStatus,
    cpfCnpjError,
    emailStatus,
    emailError,
    phoneStatus,
    phoneError,
    agreeRulesPix,
    setAgreeRulesPix,
    setNamePartner,
    setNamePartnerStatus,
    setNamePartnerError,
    setCpf,
    setCnpj,
    setCpfCnpjStatus,
    setCpfCnpjError,
    setEmail,
    setEmailStatus,
    setEmailError,
    setPhone,
    setPhoneStatus,
    setPhoneError
  } = useContactComunixFormData();

  const handleInputNamePartner = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const value = e.currentTarget.value;
      if (value.length === 0) {
        setNamePartnerStatus('Error');
        setNamePartnerError('Preenchimento obrigatório');
      } else {
        setNamePartnerStatus('');
        setNamePartnerError('');
      }
      e.currentTarget.value = value;
      setNamePartner(value);
    },
    []
  );

  const handleInputCpfCnpj = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      e.currentTarget.maxLength = 18;
      let value = e.currentTarget.value;
      value = value.replace(/\D/g, '');

      if (e.currentTarget.value.length > 14) {
        const validation = validateCnpj({
          cnpj: value,
          emptyCnpj: 'Preenchimento obrigatório',
          incorrectCnpj: 'Preenchimento incorreto'
        });
        setCpfCnpjStatus(validation.status);
        setCpfCnpjError(validation.message);
      } else {
        const validation = validateCpf({
          cpf: value,
          emptyCpf: 'Preenchimento obrigatório',
          incorrectCpf: 'Preenchimento incorreto'
        });
        setCpfCnpjStatus(validation.status);
        setCpfCnpjError(validation.message);
      }

      value = formatCpf(value);

      e.currentTarget.value = value;
      setCpfCnpj(value);
    },
    []
  );

  const handleInputEmail = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const value = e.currentTarget.value;
      const emailValid = emailValidation({
        email: value,
        emptyEmail: 'Preenchimento obrigatório',
        incorrectEmail: 'Preenchimento incorreto'
      });
      setEmailStatus(emailValid.status);
      setEmailError(emailValid.message);
      setEmail(value);
    },
    []
  );

  const handleInputPhone = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      e.currentTarget.maxLength = 15;
      let value = e.currentTarget.value;
      value = value.replace(/\D/g, '');
      if (value.length === 11) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else if (value.length === 10) {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }
      e.currentTarget.value = value;
      if (value.length > 0 && value.length < 14) {
        setPhoneError('Preenchimento incorreto');
        setPhoneStatus('Error');
      } else if (value.length === 0) {
        setPhoneError('Preenchimento obrigatório');
        setPhoneStatus('Error');
      } else {
        setPhoneError('');
        setPhoneStatus('');
      }
      setPhone(value);
    },
    []
  );

  const validForm = () => {
    if (
      namePartner === '' ||
      namePartner?.length === 1 ||
      namePartnerStatus === 'Error'
    ) {
      setNamePartnerError('Preenchimento incorreto');
      setNamePartnerStatus('Error');
      return false;
    }

    if (cpfCnpj === '' || !cpfCnpj || cpfCnpj?.length < 11  || cpfCnpjStatus === 'Error') {
      setCpfCnpjError('Preenchimento incorreto');
      setCpfCnpjStatus('Error');
      return false;
    }

    if(cpfCnpj.length > 11) {
      setCnpj(cpfCnpj)
    } else {
      setCpf(cpfCnpj)
    }

    
    if (email === '' || email?.length === 1 || emailStatus === 'Error') {
      setEmailError('Preenchimento incorreto');
      setEmailStatus('Error');
      return false;
    }

    if (phone === '' || phone?.length === 1 || phoneStatus === 'Error') {
      setPhoneError('Preenchimento incorreto');
      setPhoneStatus('Error');
      return false;
    }

    if (!agreeRulesPix) {
      return false;
    }
    
    return true;
  };

  return (
    <Modal isOpen={showContactModal} className={styles.contactModal}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div className={styles.dividerContactModal} />

        <div className={styles.formsContactModal}>
          <span className={styles.formsContactModalFirstTitle}>
            Dados do pagador
          </span>
          <div
            className={`${styles.formInput} ${namePartnerStatus === 'Error' && styles.formError
              }`}
            style={{
              marginTop: '16px',
              maxWidth: '100%'
            }}
          >
            <label htmlFor="name">Nome completo do pagador</label>
            <div>
              <input
                type="text"
                name="name"
                placeholder="Digite o seu nome completo"
                onChange={handleInputNamePartner}
                value={namePartner ?? ""}
              />
            </div>
            <div className={styles.errorMessage}>
              <p>{namePartnerError}</p>
            </div>
          </div>
          <div
            className={`${styles.formInput} ${cpfCnpjStatus === 'Error' && styles.formError
              }`}
            style={{
              marginTop: '16px',
              maxWidth: '100%'
            }}
          >
            <label htmlFor="cpf">CPF/CNPJ</label>
            <div>
              <input
                type="text"
                name="cpf"
                placeholder="CPF ou CNPJ"
                onChange={handleInputCpfCnpj}
                value={cpfCnpj || ""}
              />
            </div>
            <div className={styles.errorMessage}>
              <p>{cpfCnpjError}</p>
            </div>
          </div>
          <div
            style={{ margin: '16px 0 16px 0' }}
            className={styles.dividerContactModal}
          />

          <div className={styles.formContentPayment}>
            <div className={styles.formTitleWithSubtitle}>
              <span>Dados para contato</span>
            </div>
            <div className={styles.formSubtitle}>
              <span>
                Você será notificado por e-mail a cada movimentação do seu
                pedido.
              </span>
            </div>
            <div>
              <div
                role="xl"
                className={`${styles.formInput} ${emailStatus === 'Error' && styles.formError
                  }`}
              >
                <label htmlFor="email">E-mail</label>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="ex@exemplo.com"
                    onChange={handleInputEmail}
                    value={email ?? ""}
                  />
                </div>
                <div className={styles.errorMessage}>
                  <p>{emailError}</p>
                </div>
              </div>
              <div
                role="xl"
                className={`${styles.formInput} ${phoneStatus === 'Error' && styles.formError
                  }`}
                style={{
                  marginTop: '16px',
                  maxWidth: '100%'
                }}
              >
                <label htmlFor="phone">Telefone / WhatsApp</label>
                <div>
                  <input
                    type="text"
                    name="phone"
                    placeholder="(99) 99999-9999"
                    onChange={handleInputPhone}
                    value={phone ?? ""}
                  />
                </div>
                <div className={styles.errorMessage}>
                  <p>{phoneError}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ margin: '16px 0 16px 0' }}
          className={styles.dividerContactModal}
        />
        <div className={styles.pixRulesContainer}>
          <p className={styles.pixRulesContainerSubTitle}>
            Sobre o pagamento com PIX
          </p>
          <ul className={styles.pixContainerList}>
            <li className={styles.pixContainerLi}>
              <article className={styles.pixContainerIndicator}>1</article>
              <p className={styles.pixContainerText}>
                O pagamento deve ser feito de uma conta com mesmo CPF/CNPJ
                informado acima.
              </p>
            </li>
            <li className={styles.pixContainerLi}>
              <article className={styles.pixContainerIndicator}>2</article>
              <p className={styles.pixContainerText}>
                Confira se as informações e valor para pagamento são iguais ao
                do QR Code.
              </p>
            </li>
            <li className={styles.pixContainerLi}>
              <article className={styles.pixContainerIndicator}>3</article>
              <p className={styles.pixContainerText}>
                Os débitos selecionados serão quitados após a confirmação do
                pagamento.
              </p>
            </li>
            <li className={styles.pixContainerLi}>
              <article className={styles.pixContainerIndicator}>4</article>
              <p className={styles.pixContainerText}>
                O valor da taxas já está incluso no total a pagar
              </p>
            </li>
          </ul>
          <div
            className={styles.containerAgreeRules}
            onClick={() => setAgreeRulesPix(!agreeRulesPix)}
          >
            {agreeRulesPix ? (
              <FiCheck
                style={{
                  background: '#3477AE',
                  color: '#fff',
                  borderRadius: '4px',
                  strokeWidth: '5px',
                  padding: '3px'
                }}
                onClick={() => setAgreeRulesPix(!agreeRulesPix)}
              />
            ) : (
              <FiSquare onClick={() => setAgreeRulesPix(!agreeRulesPix)} />
            )}

            <span> Concordo com as regras</span>
          </div>
          {!agreeRulesPix && (
            <span style={{ color: '#ca1818', fontSize: '14px' }}>
              Campo Obrigatório
            </span>
          )}
        </div>
        <div className={styles.buttonsModalContact}>
          <button
            className={styles.buttonContinueModalContact}
            onClick={() => {
              if (validForm()) {
                setShowContactModal(false);
                setShowModalConfirmedPix && setShowModalConfirmedPix(true);
                getPix && getPix();
              }
            }}
          >
            Continuar
          </button>
          <button
            className={styles.buttonBackModalContact}
            onClick={() => setShowContactModal(false)}
          >
            Voltar
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalUserContactComunix;
